"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=!("undefined"==typeof window||!window.document||!window.document.createElement);exports.isBrowser=e;
//# sourceMappingURL=dom.js.map
